var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _rect2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect3, _rect4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotArrivalYet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 109,
    viewBox: "30 -30 156 159",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.9364 59.9949C84.9912 60.9401 85.0174 66.9526 85.1487 69.8407L173.367 70.6283C173.236 67.4777 172.737 60.94 171.792 59.9948C170.847 59.0496 167.722 59.0759 166.278 59.2072C139.892 59.076 86.8816 59.0497 85.9364 59.9949Z",
    fill: "var(--error-background-color, #FEEDEB)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0872 23.1547C89.0872 19.7925 91.8128 17.0669 95.175 17.0669H164.129C167.491 17.0669 170.217 19.7925 170.217 23.1547V58.8133H89.0872V23.1547Z",
    fill: "var(--error-background-color, #FEEDEB)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.201 33.3457V59.9951",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.963 18.1177H148.162",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.564 59.9953V21.9247C90.564 20.915 90.9686 19.9467 91.6887 19.2327C92.4088 18.5188 93.3855 18.1177 94.4039 18.1177H105.924",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.041 71.416H130.883H86.724",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.923 48.5742H155.842C157.879 48.5742 159.832 49.3764 161.272 50.8043C162.712 52.2323 163.521 54.1689 163.521 56.1883V59.9954H98.2436V56.1883C98.2436 54.1689 99.0527 52.2323 100.493 50.8043C101.933 49.3764 103.887 48.5742 105.923 48.5742Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.724 82.8375V63.8022C86.724 62.7925 87.1286 61.8241 87.8487 61.1102C88.5688 60.3962 89.5455 59.9951 90.5639 59.9951H171.201C172.22 59.9951 173.196 60.3962 173.916 61.1102C174.637 61.8241 175.041 62.7925 175.041 63.8022V82.8375",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.123 40.4424C125.122 40.0359 124.99 39.6403 124.746 39.3135C124.502 38.9867 124.159 38.7459 123.767 38.6264C118.443 36.7 112.603 36.7 107.279 38.6264C106.887 38.7459 106.544 38.9867 106.3 39.3135C106.056 39.6403 105.924 40.0359 105.924 40.4424V48.5743H125.123V40.4424Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.842 40.4424C155.841 40.0359 155.709 39.6403 155.465 39.3135C155.221 38.9867 154.878 38.7459 154.486 38.6264C149.162 36.7 143.322 36.7 137.998 38.6264C137.606 38.7459 137.263 38.9867 137.019 39.3135C136.775 39.6403 136.643 40.0359 136.643 40.4424V48.5743H155.842V40.4424Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.084 18.1174V10.5033C102.084 8.48389 102.893 6.54721 104.333 5.11928C105.773 3.69136 107.727 2.88916 109.763 2.88916C111.8 2.88916 113.754 3.69136 115.194 5.11928C116.634 6.54721 117.443 8.48389 117.443 10.5033V14.3103",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.842 24.2655C122.885 24.4402 122.887 24.6225 122.848 24.7981C122.809 24.9738 122.729 25.1381 122.615 25.2782C122.503 25.4205 122.359 25.5354 122.194 25.6139C122.03 25.6925 121.849 25.7326 121.667 25.7312H114.118C113.829 25.7312 113.544 25.6665 113.283 25.5419C113.023 25.4173 112.794 25.2361 112.615 25.0118C112.435 24.7874 112.309 24.5258 112.245 24.2463C112.182 23.9667 112.182 23.6766 112.248 23.3975C113.726 17.0473 113.987 14.3101 117.443 14.3101C121.041 14.3101 121.179 17.2986 122.842 24.2655Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.322 18.1174V10.5033C144.322 8.48389 145.131 6.54721 146.572 5.11928C148.012 3.69136 149.965 2.88916 152.002 2.88916C154.039 2.88916 155.992 3.69136 157.432 5.11928C158.873 6.54721 159.682 8.48389 159.682 10.5033V14.3103",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.081 24.2655C165.124 24.4402 165.126 24.6225 165.087 24.7981C165.048 24.9738 164.968 25.1381 164.854 25.2782C164.742 25.4205 164.598 25.5354 164.433 25.6139C164.269 25.6925 164.088 25.7326 163.906 25.7312H156.357C156.068 25.7312 155.782 25.6665 155.522 25.5419C155.262 25.4173 155.033 25.2361 154.854 25.0118C154.674 24.7874 154.547 24.5258 154.484 24.2463C154.42 23.9667 154.421 23.6766 154.487 23.3975C155.965 17.0473 156.226 14.3101 159.682 14.3101C163.28 14.3101 163.418 17.2986 165.081 24.2655Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.7881,
    y: 78.7515,
    width: 115.839,
    height: 10.9499,
    rx: 5.47497,
    fill: "var(--primary-text-color, #313639)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M169.626 32.5581V59.2075",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.387 17.3296H146.586",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9883 59.2072V21.1366C88.9883 20.127 89.3928 19.1586 90.113 18.4447C90.8331 17.7307 91.8098 17.3296 92.8282 17.3296H104.348",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.466 70.6284H129.307H85.1484",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.348 47.7861H154.266C156.303 47.7861 158.256 48.5883 159.697 50.0163C161.137 51.4442 161.946 53.3809 161.946 55.4002V59.2073H96.668V55.4002C96.668 53.3809 97.4771 51.4442 98.9174 50.0163C100.358 48.5883 102.311 47.7861 104.348 47.7861V47.7861Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1484 82.0499V63.0146C85.1484 62.0049 85.553 61.0365 86.2731 60.3226C86.9932 59.6086 87.9699 59.2075 88.9883 59.2075H169.626C170.644 59.2075 171.621 59.6086 172.341 60.3226C173.061 61.0365 173.466 62.0049 173.466 63.0146V82.0499",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.547 39.6543C123.546 39.2478 123.414 38.8522 123.171 38.5254C122.927 38.1986 122.584 37.9579 122.192 37.8383C116.867 35.912 111.028 35.912 105.703 37.8383C105.311 37.9579 104.968 38.1986 104.724 38.5254C104.481 38.8522 104.349 39.2478 104.348 39.6543V47.7862H123.547V39.6543Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 39.6543C154.265 39.2478 154.133 38.8522 153.89 38.5254C153.646 38.1986 153.303 37.9579 152.911 37.8383C147.586 35.912 141.747 35.912 136.422 37.8383C136.03 37.9579 135.687 38.1986 135.443 38.5254C135.2 38.8522 135.068 39.2478 135.067 39.6543V47.7862H154.266V39.6543Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100.508 17.3298V9.71568C100.508 7.69629 101.317 5.75961 102.757 4.33168C104.198 2.90376 106.151 2.10156 108.188 2.10156C110.225 2.10156 112.178 2.90376 113.618 4.33168C115.058 5.75961 115.868 7.69629 115.868 9.71568V13.5227",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.266 23.4779C121.31 23.6526 121.312 23.8349 121.272 24.0105C121.233 24.1862 121.153 24.3505 121.04 24.4906C120.927 24.6329 120.783 24.7478 120.619 24.8263C120.454 24.9049 120.274 24.945 120.091 24.9436H112.542C112.253 24.9436 111.968 24.8789 111.708 24.7543C111.447 24.6297 111.219 24.4485 111.039 24.2242C110.859 23.9998 110.733 23.7382 110.669 23.4587C110.606 23.1791 110.607 22.889 110.672 22.6099C112.15 16.2597 112.411 13.5225 115.867 13.5225C119.465 13.5225 119.604 16.511 121.266 23.4779Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.747 17.3298V9.71568C142.747 7.69629 143.556 5.75961 144.996 4.33168C146.436 2.90376 148.39 2.10156 150.426 2.10156C152.463 2.10156 154.417 2.90376 155.857 4.33168C157.297 5.75961 158.106 7.69629 158.106 9.71568V13.5227",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M163.505 23.4779C163.548 23.6526 163.55 23.8349 163.511 24.0105C163.472 24.1862 163.392 24.3505 163.278 24.4906C163.166 24.6329 163.022 24.7478 162.857 24.8263C162.693 24.9049 162.512 24.945 162.33 24.9436H154.781C154.492 24.9436 154.206 24.8789 153.946 24.7543C153.686 24.6297 153.457 24.4485 153.278 24.2242C153.098 23.9998 152.971 23.7382 152.908 23.4587C152.844 23.1791 152.845 22.889 152.911 22.6099C154.389 16.2597 154.65 13.5225 158.106 13.5225C161.704 13.5225 161.842 16.511 163.505 23.4779Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.7798,
    cy: 52.6497,
    r: 49.9178,
    fill: "var(--error-background-color, #FEEDEB)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6475,
    y: 94.4946,
    width: 47.3033,
    height: 14,
    rx: 7,
    fill: "var(--primary-text-color, #313639)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0595 52.6498C94.0595 76.5525 74.6825 95.9295 50.7798 95.9295C26.877 95.9295 7.50006 76.5525 7.50006 52.6498C7.50006 28.7471 26.877 9.37012 50.7798 9.37012C74.6825 9.37012 94.0595 28.7471 94.0595 52.6498Z",
    fill: "var(--error-color, #F44336)",
    fillOpacity: 0.35,
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3067 30.1373C74.326 26.6597 79.1357 34.5274 79.5993 36.1169",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4867 57.6213C59.2525 56.8355 56.5843 59.1114 56.341 59.714",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7819 24.6705C37.7625 21.1929 32.9529 29.0606 32.4893 30.6501",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0174 39.7256C42.1846 39.7256 42.3481 39.7752 42.4872 39.8681C42.6262 39.961 42.7346 40.093 42.7986 40.2475C42.8626 40.402 42.8793 40.5721 42.8467 40.7361C42.8141 40.9001 42.7335 41.0508 42.6153 41.169C42.497 41.2873 42.3464 41.3678 42.1824 41.4004C42.0183 41.433 41.8483 41.4163 41.6938 41.3523C41.5393 41.2883 41.4073 41.1799 41.3144 41.0409C41.2215 40.9018 41.1719 40.7384 41.1719 40.5711C41.1719 40.3469 41.261 40.1318 41.4195 39.9732C41.5781 39.8147 41.7932 39.7256 42.0174 39.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7882 39.7256C70.9555 39.7256 71.1189 39.7752 71.258 39.8681C71.397 39.961 71.5054 40.093 71.5694 40.2475C71.6334 40.402 71.6501 40.5721 71.6175 40.7361C71.5849 40.9001 71.5044 41.0508 71.3861 41.169C71.2679 41.2873 71.1172 41.3678 70.9532 41.4004C70.7892 41.433 70.6192 41.4163 70.4647 41.3523C70.3101 41.2883 70.1781 41.1799 70.0852 41.0409C69.9923 40.9018 69.9427 40.7384 69.9427 40.5711C69.9427 40.3469 70.0318 40.1318 70.1903 39.9732C70.3489 39.8147 70.564 39.7256 70.7882 39.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9764 79.5401L55.5294 73.6855L61.0412 72.8597C61.5839 72.8296 62.0925 72.5852 62.455 72.1802C62.8175 71.7752 63.0042 71.2427 62.9742 70.7C62.9441 70.1573 62.6997 69.6488 62.2947 69.2863C61.8896 68.9238 61.3572 68.737 60.8145 68.7671L44.9752 69.2836C44.9752 69.2836 45.7997 60.7907 43.0336 60.7907C40.2676 60.7906 40.2935 63.9381 39.2234 69.36L28.6149 78.1988",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7041,
    y: 45.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.9506,
    y: 45.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170, -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.65143 21.526C2.65143 26.4484 4.60682 31.1691 8.08744 34.6497C11.5681 38.1303 16.2888 40.0857 21.2111 40.0857C26.1335 40.0857 30.8542 38.1303 34.3348 34.6497C37.8154 31.1691 39.7708 26.4484 39.7708 21.526C39.7708 16.6037 37.8154 11.8829 34.3348 8.40232C30.8542 4.9217 26.1335 2.96631 21.2111 2.96631C16.2888 2.96631 11.5681 4.9217 8.08744 8.40232C4.60682 11.8829 2.65143 16.6037 2.65143 21.526Z",
    fill: "var(--error-color, #F44336)",
    fillOpacity: 0.35,
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5598 21.5259C18.5598 22.2291 18.8391 22.9035 19.3363 23.4007C19.8336 23.8979 20.5079 24.1773 21.2111 24.1773C21.9143 24.1773 22.5887 23.8979 23.086 23.4007C23.5832 22.9035 23.8625 22.2291 23.8625 21.5259C23.8625 20.8227 23.5832 20.1483 23.086 19.6511C22.5887 19.1539 21.9143 18.8745 21.2111 18.8745C20.5079 18.8745 19.8336 19.1539 19.3363 19.6511C18.8391 20.1483 18.5598 20.8227 18.5598 21.5259Z",
    fill: "white",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2111 18.8746V9.59473",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0862 23.4009L27.8392 28.1539",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotArrivalYet);
export default __webpack_public_path__ + "static/media/not_arrival_yet.846f47b5.svg";
export { ForwardRef as ReactComponent };